(function () {
  function initMadiJaynePaints(root) {
    var scope = root || document;

    scope.querySelectorAll('a[href^="#"]').forEach(function (a) {
      if (a.dataset.mjpSmooth === 'true') return;
      a.dataset.mjpSmooth = 'true';
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id === '#') return;
        var el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    var nav = document.querySelector('.mjp-nav');
    if (nav && nav.dataset.mjpScrollBound !== 'true') {
      nav.dataset.mjpScrollBound = 'true';
      var updateNavState = function () {
        nav.classList.toggle('is-scrolled', window.scrollY > 20);
      };
      updateNavState();
      window.addEventListener('scroll', updateNavState, { passive: true });
    }


    scope.querySelectorAll('.commission-size-grid').forEach(function (grid) {
      if (grid.dataset.mjpSizeBound === 'true') return;
      grid.dataset.mjpSizeBound = 'true';

      function syncActiveSize() {
        grid.querySelectorAll('.size-radio').forEach(function (label) {
          var input = label.querySelector('input[type="radio"]');
          label.classList.toggle('active', !!input && input.checked);
        });
      }

      grid.addEventListener('change', syncActiveSize);
      grid.addEventListener('click', function (event) {
        var label = event.target.closest('.size-radio');
        if (!label || !grid.contains(label)) return;

        var input = label.querySelector('input[type="radio"]');
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        syncActiveSize();
      });

      syncActiveSize();
    });

    scope.querySelectorAll('[data-mjp-cart-form]').forEach(function (form) {
      if (form.dataset.mjpQuantityBound === 'true') return;
      form.dataset.mjpQuantityBound = 'true';

      var updateButton = form.querySelector('button[name="update"]');
      var updateTimer;

      function normalizeQuantity(input) {
        var minimum = Number(input.min || 1);
        var maximum = input.max ? Number(input.max) : Infinity;
        var step = Number(input.step || 1);
        var value = Number(input.value);

        if (!Number.isFinite(value)) value = minimum;
        value = Math.max(minimum, Math.min(maximum, value));
        value = minimum + Math.round((value - minimum) / step) * step;
        input.value = Math.max(minimum, Math.min(maximum, value));
      }

      function scheduleCartUpdate() {
        window.clearTimeout(updateTimer);
        updateTimer = window.setTimeout(function () {
          if (!form.isConnected || !updateButton) return;
          if (typeof form.requestSubmit === 'function') form.requestSubmit(updateButton);
          else updateButton.click();
        }, 500);
      }

      form.addEventListener('click', function (event) {
        var button = event.target.closest('[data-mjp-quantity-action]');
        if (!button || !form.contains(button)) return;

        var input = button.parentElement.querySelector('.mjp-cart-quantity-input');
        if (!input) return;

        var step = Number(input.step || 1);
        var direction = button.dataset.mjpQuantityAction === 'increase' ? 1 : -1;
        input.value = Number(input.value || input.min || 1) + (step * direction);
        normalizeQuantity(input);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      form.addEventListener('change', function (event) {
        if (!event.target.matches('.mjp-cart-quantity-input')) return;
        normalizeQuantity(event.target);
        scheduleCartUpdate();
      });

      form.addEventListener('submit', function () {
        window.clearTimeout(updateTimer);
      });
    });

    scope.querySelectorAll('[data-mjp-painted-paws]').forEach(function (productRoot) {
      if (productRoot.dataset.mjpPaintedPawsBound === 'true') return;
      productRoot.dataset.mjpPaintedPawsBound = 'true';

      var variantInput = productRoot.querySelector('[data-mjp-painted-paws-id]');
      var price = productRoot.querySelector('[data-mjp-painted-paws-price]');
      var submit = productRoot.querySelector('[data-mjp-painted-paws-submit]');
      var image = productRoot.querySelector('[data-mjp-painted-paws-media] img');
      var quantityInput = productRoot.querySelector('[data-mjp-paws-quantity-input]');
      var imageTimer;

      function normalizePawsQuantity() {
        if (!quantityInput) return;
        var value = parseInt(quantityInput.value, 10);
        quantityInput.value = Number.isFinite(value) ? Math.max(1, value) : 1;
      }

      function swipeToImage(src, alt) {
        if (!image || !src || image.getAttribute('src') === src) return;
        window.clearTimeout(imageTimer);
        image.classList.remove('is-swiping-in');
        image.classList.add('is-swiping-out');

        imageTimer = window.setTimeout(function () {
          image.src = src;
          image.removeAttribute('srcset');
          image.alt = alt || '';
          image.classList.remove('is-swiping-out');
          image.classList.add('is-swiping-in');
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              image.classList.remove('is-swiping-in');
            });
          });
        }, 180);
      }

      productRoot.addEventListener('click', function (event) {
        var breedButton = event.target.closest('[data-mjp-breed-option]');
        if (breedButton && productRoot.contains(breedButton)) {
          productRoot.querySelectorAll('[data-mjp-breed-option]').forEach(function (button) {
            var selected = button === breedButton;
            button.classList.toggle('is-selected', selected);
            button.setAttribute('aria-checked', selected ? 'true' : 'false');
          });

          if (variantInput) variantInput.value = breedButton.dataset.variantId;
          if (price) price.textContent = breedButton.dataset.variantPrice;

          if (submit) {
            var available = breedButton.dataset.variantAvailable === 'true';
            submit.disabled = !available;
            submit.textContent = available ? submit.dataset.availableLabel : 'Sold out';
          }

          swipeToImage(breedButton.dataset.variantImage, breedButton.dataset.variantImageAlt);

          if (window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', breedButton.dataset.variantId);
            window.history.replaceState({}, '', url.toString());
          }
          return;
        }

        var quantityButton = event.target.closest('[data-mjp-paws-quantity]');
        if (!quantityButton || !productRoot.contains(quantityButton) || !quantityInput) return;
        normalizePawsQuantity();
        quantityInput.value = Number(quantityInput.value) + (quantityButton.dataset.mjpPawsQuantity === 'increase' ? 1 : -1);
        normalizePawsQuantity();
      });

      if (quantityInput) quantityInput.addEventListener('change', normalizePawsQuantity);
    });

    if (!('IntersectionObserver' in window)) return;

    if (!window.__mjpObserver) {
      window.__mjpObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            entry.target.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
          }
        });
      }, { threshold: 0.1 });
    }

    scope.querySelectorAll('.shop-card, .snail-tier, .snail-single-offer, .testimonial-card, .gallery-item, .faq-item, .process-step, .mjp-product-info, .mjp-product-visual').forEach(function (el) {
      if (el.dataset.mjpObserved === 'true') return;
      el.dataset.mjpObserved = 'true';
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      window.__mjpObserver.observe(el);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initMadiJaynePaints(document); });
  document.addEventListener('shopify:section:load', function (event) { initMadiJaynePaints(event.target); });
})();
